var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('uploader', _vm._g(_vm._b({ attrs: { "file-list": _vm.fileList, "before-upload": _vm.handleBeforeUpload, "on-success": _vm.handleUploadSuccess, "on-change": _vm.handleUploadChange, "multiple": _vm.multiple } }, 'uploader', _vm.config.params, false), _vm.$listeners), [_c('i', { staticClass: "el-icon-plus" }), _vm._v(" "), _c('div', { staticClass: "el-upload__tip", attrs: { "slot": "tip" }, slot: "tip" }, [_vm._v(_vm._s(_vm.config.params.tip))])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };